import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { BaseUrl } from '../API/Url';

export default function ChangeProtector(props) {
    const { UserId } = useParams();
    const [CheckUser, setCheckUser] = useState(null); // Initial state as null
    const [loading, setLoading] = useState(true); // Loading state to track API request



    const CheckForUser = async () => {
        try {
            const res = await axios.get(`${BaseUrl}/auth/CheckForUser/${UserId}`);
            setCheckUser(res.data.status);

        } catch (error) {
            setCheckUser(false); // Handle error case
        } finally {
            setLoading(false); // Set loading to false after API call
        }
    }

    useEffect(() => {
        if (UserId) {
            CheckForUser();
        }
    }, [UserId]);

    if (loading) {
        return <div>Loading...</div>; // Display loading state
    }

    if (CheckUser) {
        return props.children;
    } else {
        return <Navigate to={"/Login"} />;
    }
}
